module.exports = __webpack_public_path__ + "img/1544466281.456a7dd5.jpg";